import { useMemo, useState } from "react";
import KickImage from 'Reuseables/KickImage';
import { Link } from 'react-router-dom';
import Styles from './Card.module.scss';
import { emptyImage } from "utils"

type CardProps = {
  name: string;
  link: string;
  date: string;
  productImg: string;
  category?: string;
}
const Card: React.FC<CardProps> = ({ name, link, date, productImg, category }) => {
  const [img, setImg] = useState(productImg);

  const isInvalidDate = useMemo(() => {
    if (!date || date == 'Invalid date') {
      return true
    }
    return false
  }, [date])
  return <Link to={link} className={Styles[`nur-card`]}>
    <div>
      {!isInvalidDate ? <div className={Styles['date-box']}><span>{date}</span></div> : null}
      <p className={Styles['name']}>{name}</p>
    </div>
    <div className={Styles['img-box']}>
      <KickImage src={img} alt={name} onError={() => setImg(emptyImage(category))} />
    </div>
  </Link>
}

export default Card